module.exports = "https://cdn.hellotech.com/client-assets/camera_wide_ddc9edd40d63e39eb103c80039a92900.jpg";